<template>
  <img
    class="cpro-img"
    v-if="deluge?.canvaspro_core_info?.product_name.toUpperCase() === 'OMNI'"
    :src="omniSvg" />
  <img
    class="cpro-img"
    v-if="deluge?.canvaspro_core_info?.product_name.toUpperCase() === 'ONE'"
    :src="oneSvg" />
  <img
    class="cpro-img"
    v-if="deluge?.canvaspro_core_info?.product_name.toUpperCase() === 'ORB'"
    :src="orbSvg" />
  <div class="header CanvasProFont">
    {{ header }}
  </div>
  <div class="sub-header CanvasProFont">
    {{ subHeader }}
  </div>
</template>
<script setup>
import omniSvg from '../../assets/OmniLight.svg';
import oneSvg from '../../assets/OneLight.svg';
import orbSvg from '../../assets/CanvasPro_Orb_Anagram_White_7680px.svg';
import { deluge } from '@/stores/deluge.js';

const props = defineProps(['header', 'subHeader']);
</script>
<style scoped>
.header {
  color: white;
  font-size: 24px;
  font-weight: bolder;
}
.sub-header {
  padding-bottom: 50px;
  color: white;
  opacity: 0.8;
}
.cpro-img {
  margin-bottom: 50px;
  margin-left: 50px;
  margin-right: 50px;
  width: 120px;
  height: 120px;
}
</style>
